import axios from 'axios'
import Qs from 'qs'
import AscentiaService from './ascentiaService'

const values = {
  fleetFullConnectivity: null,
  connectivityData: null,
  fullConnectivityData: null,
}

const getters = {
  fleetFullConnectivity() {
    const url = '/NewDataFiles/ConnectivityIssues'
    const params = {
      daysBack: -1,
    }
    return axios.get(url, {
      params,
    })
  },
  connectivityData(airlineDetails) {
    const url = '/NewDataFiles/Summary'
    const params = {
      daysBack: airlineDetails.daysBack,
    }
    if (airlineDetails.airlineIds && airlineDetails.airlineIds.length > 0) {
      params.airlineIds = airlineDetails.airlineIds
    }
    return axios.get(url, {
      params,
      paramsSerializer: function (params) {
        // http://www.npmjs.com/package/qs
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
    })
  },
  fullConnectivityData(airlineDetails) {
    const url = '/NewDataFiles/Summary'
    const params = {
      daysBack: -1,
    }
    if (airlineDetails.airlineIds && airlineDetails.airlineIds.length > 0) {
      params.airlineIds = airlineDetails.airlineIds
    }
    return axios.get(url, {
      params,
      paramsSerializer: function (params) {
        // http://www.npmjs.com/package/qs
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
    })
  },
}

export default class ConnectivityService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
